<template>
  <fragment>
    <hero-header page-name=" " hero-title="competitions"/>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="6" lg="4" v-for="(palyazat, palyazatIndex) in $store.getters.getCompetitions" :key="palyazatIndex">
          <v-card>
            <v-card-title class="pa-0">
              <v-img :src="palyazat.cardImage"/>
            </v-card-title>
            <v-divider />
            <v-card-title>
              {{ palyazat.title }}
            </v-card-title>
            <v-card-text>
              <PalyazatContentItem v-for="(cardBlock, cardBlockIndex) in palyazat.cardBlocks"
                                   :key="cardBlockIndex"
                                   :title="cardBlock.title"
                                   :text="cardBlock.text"
                                   class="my-5"
              />
            </v-card-text>
            <v-card-actions class="px-4 pb-4">
              <v-spacer />
              <v-btn text color="primary" @click="showDetails(palyazat.title)">További részletek</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
// eslint-disable-next-line import/extensions
import heroHeader from '@/components/heroHeader';
import PalyazatContentItem from '@/components/Palyazat/PalyazatContentItem';

export default {
  name: 'PalyazatokPage',
  components: {
    heroHeader,
    PalyazatContentItem,
  },
  props: {
    //
  },
  data() {
    return {
      //
    };
  },
  methods: {
    showDetails(title) {
      this.$router.push(`/palyazat/${title}`);
    },
  },
};
</script>

<style scoped>

</style>
